/**
 * @generated SignedSource<<163ad165c3eb7e0ea96642094fb20a3b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpsertProgramFolderInput = {
  clientMutationId?: string | null | undefined;
  id?: string | null | undefined;
  name: string;
};
export type UpsertProgramFolderMutation$variables = {
  input: UpsertProgramFolderInput;
};
export type UpsertProgramFolderMutation$data = {
  readonly upsertProgramFolder: {
    readonly programFolder: {
      readonly " $fragmentSpreads": FragmentRefs<"ProgramFolderCard_folder">;
    } | null | undefined;
  } | null | undefined;
};
export type UpsertProgramFolderMutation = {
  response: UpsertProgramFolderMutation$data;
  variables: UpsertProgramFolderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertProgramFolderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertProgramFolderPayload",
        "kind": "LinkedField",
        "name": "upsertProgramFolder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramFolder",
            "kind": "LinkedField",
            "name": "programFolder",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProgramFolderCard_folder"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpsertProgramFolderMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpsertProgramFolderPayload",
        "kind": "LinkedField",
        "name": "upsertProgramFolder",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProgramFolder",
            "kind": "LinkedField",
            "name": "programFolder",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "10754fb142314bc7d9e9d0e13a35f881",
    "id": null,
    "metadata": {},
    "name": "UpsertProgramFolderMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertProgramFolderMutation(\n  $input: UpsertProgramFolderInput!\n) {\n  upsertProgramFolder(input: $input) {\n    programFolder {\n      ...ProgramFolderCard_folder\n      id\n    }\n  }\n}\n\nfragment ProgramFolderCard_folder on ProgramFolder {\n  id\n  name\n}\n"
  }
};
})();

(node as any).hash = "78fa675e57b1c8cff5c79f30074f4d50";

export default node;
